"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const storyCreateStates_1 = require("./storyCreateStates");
const react_i18next_1 = require("react-i18next");
const notistack_1 = require("notistack");
const api_1 = require("@/api");
const functions_1 = require("@/common/functions");
const errors_1 = require("@/common/errors");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1({ originStory }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const isUpdate = window.location.pathname.includes('update');
    const compressImg = (0, recoil_1.useRecoilValue)(storyCreateStates_1.storyCreateFileState);
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const { title, auth_status, category_id, public_status, closed, id } = (0, recoil_1.useRecoilValue)(storyCreateStates_1.storyDataState);
    const { enqueueSnackbar, closeSnackbar } = (0, notistack_1.useSnackbar)();
    const snackbarOptions = {
        variant: 'warning',
        autoHideDuration: 4000,
        onClick: () => closeSnackbar(),
    };
    const generateErrors = () => {
        let errors = [];
        if (!category_id)
            errors.unshift(t('어떤 스토리인가요?를 선택해주세요'));
        if (!title)
            errors.unshift(t('제목을 입력해 주세요'));
        return errors;
    };
    const makeFormData = () => {
        const formData = new FormData();
        if (compressImg)
            formData.append('thumbnail', compressImg);
        if (originStory) {
            const { title: originTitle, category_id: originCategoryId, public_status: originPublicStatus, closed: originClosed, } = originStory;
            if (title !== originTitle)
                formData.append('title', title);
            if (category_id !== originCategoryId)
                formData.append('category_id', category_id);
            if (public_status !== originPublicStatus)
                formData.append('public_status', public_status.toString());
            if (closed !== originClosed)
                formData.append('closed', closed.toString());
        }
        else {
            formData.append('title', title);
            formData.append('category_id', category_id);
            formData.append('auth_status', auth_status.toString());
            formData.append('public_status', public_status.toString());
        }
        return formData;
    };
    const submitStoryData = () => {
        const errorsArr = generateErrors();
        setIsSubmitting(true);
        if (errorsArr.length) {
            errorsArr.forEach((errorMsg) => enqueueSnackbar(errorMsg, snackbarOptions));
            setIsSubmitting(false);
        }
        else {
            const updateFormData = isUpdate ? api_1.patchFormData : api_1.postFormData;
            updateFormData(`/api/v1/plays/stories${isUpdate ? `/${id}` : ''}`, makeFormData())
                .then(res => {
                if (res.status === 200 || res.status === 201) {
                    window.location.replace(`/plays/story-view/${res.data.result.id}`);
                }
            })
                .catch(() => (0, functions_1.showToastMessage)({ message: (0, errors_1.commonErrorMsg)() }))
                .finally(() => setIsSubmitting(false));
        }
    };
    return ((0, jsx_runtime_1.jsx)(CompleteWrapper, Object.assign({ maxWidth768: maxWidth768 }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: "orange_filled", fullWidth: true, onClick: () => submitStoryData(), disabled: isSubmitting, css: { fontSize: 18 } }, { children: isSubmitting ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 24, color: "info", thickness: 4 })) : isUpdate ? ((0, jsx_runtime_1.jsx)("span", { children: t('수정 완료') })) : ((0, jsx_runtime_1.jsx)("span", { children: t('등록 완료') })) })) })));
}
exports.default = default_1;
// eslint-disable-next-line prettier/prettier
const CompleteWrapper = styled_1.default.div `
  width: 100%;
  max-width: 800px;
  padding: 20px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.0001) 0%,
    rgba(255, 255, 255, 0.6) 11.59%,
    #ffffff 30.42%
  );
  z-index: 10;
`;
